import React, { useRef, useEffect, useState } from 'react';

const CameraBox = () => {
  const videoRef = useRef(null);
  const [devices, setDevices] = useState([]);
  const [selectedDeviceId, setSelectedDeviceId] = useState('');
  const [stream, setStream] = useState(null);

  // Liste des caméras disponibles
  useEffect(() => {
    navigator.mediaDevices.enumerateDevices().then(devices => {
      const videoDevices = devices.filter(d => d.kind === 'videoinput');
      setDevices(videoDevices);
      if (videoDevices.length > 0 && !selectedDeviceId) {
        setSelectedDeviceId(videoDevices[0].deviceId);
      }
    });
    // eslint-disable-next-line
  }, []);

  // Démarre la caméra selon l'angle choisi
  useEffect(() => {
    let localStream;
    const startCamera = async () => {
      if (!selectedDeviceId) return;
      if (stream) {
        stream.getTracks().forEach(track => track.stop());
      }
      try {
        localStream = await navigator.mediaDevices.getUserMedia({
          video: { deviceId: { exact: selectedDeviceId } },
          audio: false
        });
        setStream(localStream);
        if (videoRef.current) {
          videoRef.current.srcObject = localStream;
        }
      } catch (err) {
        // Gérer l'erreur
      }
    };
    startCamera();
    return () => {
      if (localStream) {
        localStream.getTracks().forEach(track => track.stop());
      }
    };
    // eslint-disable-next-line
  }, [selectedDeviceId]);

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <select
        value={selectedDeviceId}
        onChange={e => setSelectedDeviceId(e.target.value)}
        style={{ marginBottom: 8, borderRadius: 8, padding: 6 }}
      >
        {devices.map(device => (
          <option key={device.deviceId} value={device.deviceId}>
            {device.label || `Caméra ${device.deviceId.slice(0, 5)}`}
          </option>
        ))}
      </select>
      <video
        ref={videoRef}
        autoPlay
        playsInline
        muted
        style={{
          width: '100%',
          height: '350px',
          objectFit: 'cover',
          background: '#222',
          borderRadius: '20px',
        }}
      />
    </div>
  );
};

export default CameraBox; 